export function mergeMailRoomPages(existing = [], incoming = []) {
  const byId = new Map();
  const order = [];

  (existing || []).forEach((room) => {
    if (!room?.id) return;
    const id = String(room.id);
    byId.set(id, room);
    order.push(id);
  });

  (incoming || []).forEach((room) => {
    if (!room?.id) return;
    const id = String(room.id);
    if (!byId.has(id)) order.push(id);
    byId.set(id, room);
  });

  return order.map((id) => byId.get(id)).filter(Boolean);
}

export function hasMoreMailRooms(incoming = [], pageSize = 0) {
  return Number(pageSize) > 0 && (incoming || []).length >= Number(pageSize);
}

export function nextMailRoomPage(page = 0) {
  const value = Number(page);
  return Number.isFinite(value) && value >= 0 ? value + 1 : 1;
}
